import { isNodeCollapsed, sectionKey, rootSectionKey } from './utils.js';

export function buildSectionNode(msId, type, label, childrenHtml, count) {
  var key = sectionKey(msId, type);
  var isCollapsed = isNodeCollapsed(key, false);
  var h = '<div class="wf-node wf-node--section wf-node--section-' + type + (isCollapsed ? ' wf-node--collapsed' : '') + '" data-key="' + key + '">';
  h += '<div class="wf-row">';
  h += '<button class="wf-triangle" data-fn="toggleCollapse" data-key="' + key + '">';
  h += '<span class="wf-tri-icon ' + (isCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span>';
  h += '</button>';
  h += '<button class="wf-bullet wf-bullet--section" data-fn="zoomTo" data-level="section" data-sectionkey="' + key + '" title="Focus on ' + label + '"></button>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--section">' + label + '</span></div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-type="section" data-key="' + key + '" data-sectiontype="' + type + '" data-msid="' + msId + '">&#8943;</button>';
  h += '</div>';
  if (!isCollapsed) {
    h += '<div class="wf-children">';
    h += childrenHtml;
    h += '</div>';
  }
  h += '</div>';
  return h;
}

export function buildRootSection(name, label, childrenFn) {
  var key = rootSectionKey(name);
  var isCollapsed = isNodeCollapsed(key, false);
  var h = '<div class="wf-node wf-node--root wf-node--root-' + name + (isCollapsed ? ' wf-node--collapsed' : '') + '" data-key="' + key + '">';
  h += '<div class="wf-row">';
  h += '<button class="wf-triangle" data-fn="toggleCollapse" data-key="' + key + '">';
  h += '<span class="wf-tri-icon ' + (isCollapsed ? 'wf-tri-icon--right' : 'wf-tri-icon--down') + '"></span>';
  h += '</button>';
  h += '<button class="wf-bullet wf-bullet--root" data-fn="zoomTo" data-level="root" data-rootname="' + name + '" title="Focus on ' + label + '"></button>';
  h += '<div class="wf-text-wrap"><span class="wf-node-text wf-node-text--root">' + label + '</span></div>';
  h += '<button class="wf-menu-btn" data-fn="openMenu" data-key="' + key + '" data-type="root" data-rootname="' + name + '">&#8943;</button>';
  h += '</div>';
  if (!isCollapsed) {
    h += '<div class="wf-children">';
    h += childrenFn();
    h += '</div>';
  }
  h += '</div>';
  return h;
}
